import { render } from "./ClassicEditor.vue?vue&type=template&id=5d4b8d80"
import script from "./ClassicEditor.vue?vue&type=script&lang=js"
export * from "./ClassicEditor.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1917936756/src/quotation-sales/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__